<template>
  <!-- 公共水印 -->
  <Watermark v-bind="{...watermarkConfig}">
    <slot></slot>
  </Watermark>
</template>

<script>
import Watermark from './index.vue';
import {bus} from '@/utils/eventEmitter';

export default {
  components: {
    Watermark
  },
  data(){
    return {
      watermarkConfig: {
        content: this.getInitWatermarkContent(),
        rotate: -10,
        gap: [130, 160],
      },
    }
  },
  mounted(){
    bus.on('updateWatermarkConfig', this.updateWatermarkConfig);
  },
  methods: {
    getInitWatermarkContent(){
      let userInfo = {};
      const userInfoStorage = localStorage.getItem("userInfo");
      try {
        if (userInfoStorage) userInfo = JSON.parse(userInfoStorage);
      } catch (error) {
        console.log(error);
      }
      const {name, phone} = userInfo;
      return name ? `${name} ${phone ? phone.slice(-4) : ''}` : '黑牛科技';
    },
    // 更新水印配置
    updateWatermarkConfig(payload={}){
      this.watermarkConfig = {...this.watermarkConfig, ...payload};
    },
  }
}
</script>